import script from "./PoliticaPrivacidad.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=476ee63b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-476ee63b"]])

export default __exports__